export var availableSessionsLabel = function (nb) {
    return nb + " " + (nb === 1 ? 'session disponible' : 'sessions disponibles');
};
//# sourceMappingURL=plural.js.map